import Layout from '@src/layout/Layout.vue'

import { GroupRoute, Route } from './ARoute'
import overviewRoute from './routes/overview'
import profileRoute from './routes/profile'
import symbolRoute from './routes/symbols'
import systemRoute from './routes/systems'
import workspaceRoute from './routes/workspaces'

export const asyncRoutes = [
  profileRoute,
  Route.withPath('/', Layout)
    .withAuth()
    .addChildren(
      GroupRoute.create(
        [
          Route.withPath('', 'dashboard/dashboard').withTitle(
            'sidebar.dashboard.name'
          ),
          Route.withPath('activity-log', 'dashboard/activitylog').withName(
            'activitylog'
          ),
        ],
        (group) => {
          group
            .withPrefix('bang-dieu-khien')
            .withNamespace('dashboard')
            .requireHasAnyInScopes(['dashboard'])
          return group
        }
      )
    )
    .addChildren([
      Route.withPageLayout('du-lieu').addChildren([
        Route.redirect('', { name: 'workspaces' }).withName('database'),
        workspaceRoute,
        Route.withPath('lop-ban-do', 'layers/all-layers/all-layer-main')
          .withName('layers')
          .withTitle('sidebar.layer.name'),
        // Route.withPath(
        //   'nhom-lop-ban-do',
        //   'layer-group/all-layer-groups/all-layer-group-main'
        // )
        //   .withName('layer-group')
        //   .withTitle('sidebar.layer-group.name'),
        Route.withPath('trinh-bay', 'styles/all-styles-main')
          .requireHasAnyInScopes(['style-management'])
          .withName('styles')
          .withTitle('sidebar.style.name'),
      ]),
    ])
    .addChildren([
      systemRoute,
      symbolRoute,
      overviewRoute,

      Route.withPath('/khoa-api', 'keys/key-main')
        .requireHasAnyInScopes(['key-management'])
        .withName('keys')
        .withTitle('sidebar.key.name'),
      Route.withPath('/ban-do', 'map/map-main')
        .withName('map')
        .withTitle('sidebar.map-preview.name'),
        Route.withPath('/ban-do-chia-se', 'share/share-table')
        .withName('map-share-list')
        .withTitle('sidebar.map-share.name'),

      Route.withPath('/sao-luu', 'backup/backup-main')
        .requireHasAnyInScopes(['backup-management'])
        .withName('backup')
        .withTitleText('Sao lưu dữ liệu'),

      Route.withPath('/giam-sat', 'monitor/monitor-dashboard')
        .withName('monitor-dashboard')
        .withTitleText('Giám sát vận hành')
        .withIcon('mdi-monitor-dashboard')
        .withAuth(),

      Route.withPath('/tien-trinh', 'task/task-main')
        //  .requireHasAnyInScopes(['task-management'])
        .withName('tasks')
        .withTitleText('Tiến trình'),

      Route.withPath('/ban-do-nen', 'basemap/basemap-main')
        .requireHasAnyInScopes(['basemap-management'])
        .withName('basemaps')
        .withTitle('sidebar.style.name'),
    ]),
]
